export const payload = {
  receiveMutation: 'RECEIVE_SALESREP',
  receivingMutation: 'RECEIVING_SALESREP',
  receiveMetadataMutation: 'RECEIVE_SALESREP_METADATA',
  savingMutation: 'SAVING_SALESREP',
  updatingMutation: 'UPDATING_SALESREP',
  deleteMutation: 'DELETE_SALESREP',
  deletingMutation: 'DELETING_SALESREP',
  incrementMutation: 'INCREMENT_SALESREP_COUNT',
  resetMetaMutation: 'RESET_SALESREP_META',
  clearMutation: 'CLEAR_SALESREP_STATE',
  moduleName: 'salesrep',
  endpoint: 'salesreps',
  defaultModelGetter: 'getDefaultSalesrep',
  searchableFields: ['name']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Salesreps/actionPayload.js